<template>
  <TimerLabel
    v-if="finishedAt"
    key="timer-label"
    :seconds="seconds"
  />

  <TimerSeconds
    v-else
    key="timer-fixed"
    :value="seconds"
  />
</template>

<script>
import TimerSeconds from '@/components/TimerSeconds'
import TimerLabel from '@/components/TimerLabel'

export default {
  components: {
    TimerSeconds,
    TimerLabel
  },

  props: {
    createdAt: {
      type: Number,
      default: 0
    },

    finishedAt: {
      type: Number,
      default: 0
    }
  },

  computed: {
    seconds () {
      const endedAt = this.finishedAt || Date.now()
      return Math.floor((endedAt - this.createdAt) / 1000)
    }
  }
}
</script>
